import { Component } from "react";
import apiClient from "../api";
import settings from "../settings";
import MediaSummary from "../MediaSummary/MediaSummary";
import PaginationControl from "../PaginationControl/PaginationControl";
// import FavoritesDetails from "../FavoritesDetails/FavoritesDetails";
import { getParameterByName } from "../util";

class FavoritesDetails extends Component{

    constructor(props){
        super(props);
        this.listName = '';
        this.mediaItems = [];
        this.totalPages = 0;
    }

    componentDidMount = () => {
        
        let p = getParameterByName('p');
        this.mediaItems = [];
        if(isNaN(p))
            p = 1;
        apiClient.get(`${settings.api_url}api/favorites?p=${p}`)
        .then(list_data => {
            
            this.totalPages = Math.ceil(list_data.data.total/20);
            list_data.data.data.forEach((element,i) => {
                this.listName = "Favorites";
                if(element.item_type === 'tv'){
                    element.item_type = 'tvshow';
                }
                // this.mediaItems.push(element);
                this.forceUpdate();
            });
            this.mediaItems = list_data.data.data;
        });
    }

    render = () => {
        if(typeof this.mediaItems === 'undefined')
        return <></>
        else{
            return (
                <>
                    <div className="content-title"><h2 className="page-title">Your Favorites</h2></div>                       
                    {
                        this.mediaItems.length > 0?this.mediaItems.map((item,i) => {
                            return <MediaSummary 
                                size={"normal"} 
                                passThru={() => this.detailsPassThru("details",item.item_id,item.item_type==='tvshow'?'tv':'movie')} 
                                key={"item"+item.item_id} 
                                mediaID={item.item_id} 
                                mediaType={item.item_type==='tvshow'?'tv':item.item_type} 
                                poster_path={item.item_type==="person"?item.profile_path:item.item_type==="episode"?item.poster_path:item.poster_path} 
                                vote_average={item.vote_average} 
                                media_name={item.item_type==='tvshow'?item.item_title:item.item_title}
                                season={item.season}
                                episode={item.episode}
                                />
                        }):<></>
                    }
                    <PaginationControl contentPage="list" maxentries={5} pageNumberCallback={null} pageQueryVariable="page" q={null} currentPage={this.props.p} lastPage={this.totalPages} link={`?page=favorites&p=`} />
                </>
            )
        }
    }
}
export default FavoritesDetails;